module.exports = __webpack_public_path__ + "img/no_session.70623df4.png";